import React from 'react'
import Loadable from 'react-loadable'

import Loading from '../../components/loader/Loader'
import RolesEnum from '../../Enum/RolesEnum';

const RevendasComponent = Loadable({
  loader: () => import('../../../pages/revenda/Revendas'),
  loading: () => <Loading />
})

const RevendaComponent = Loadable({
  loader: () => import('../../../pages/revenda/formulario/RevendaFormulario'),
  loading: () => <Loading />
})

const MotoristasComponent = Loadable({
  loader: () => import('../../../pages/motorista/Motoristas'),
  loading: () => <Loading />
})

export default [
  {
    path: '/revendas/new',
    title: 'Nova Revenda',
    component: RevendaComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas]
  },
  {
    path: '/revendas/:id/edit',
    title: 'Revenda',
    component: RevendaComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas, RolesEnum.Organizacao]
  },
  {
    path: '/revendas/:id/motoristas',
    title: 'Motoristas',
    component: MotoristasComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas, RolesEnum.Organizacao]
  },
  {
    path: '/revendas/list/:page',
    title: 'Revendas',
    component: RevendasComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas]
  }
]
